<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="btn-toolbar justify-content-between mb-1" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12">
                    <span class="float-left"><toggle v-model="markAllWithFinancialControl"></toggle></span>
                    <span class="float-left ml-3">{{ $t('budgetReport.markAllAsFinancialControl') }}</span>

                    <h5 v-if="unloadedParticipants && unloadedParticipants.length > 0" class="text-warning ml-3 pt-2">Съществуват незаредени участници
                        <button
                            class="btn btn-warning btn-sm"
                            data-toggle="tooltip"
                            title="Добавяне на участници"
                            @click.stop="loadNewNotSavedBudgetReport"
                        >
                            <span class="badge badge-warning">{{ unloadedParticipants.length }}</span>
                        </button>
                    </h5>

                </div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery"
                        type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch"
                        v-on:keyup.esc.stop="searchQuery = ''"
                    >
                    <button class="btn btn-secondary"
                            @click.stop="searchQuery = ''">
                        <i class="fas fa-times"></i>
                        <span style="font-size: 0.9rem;" class="pl-2">{{ $t('buttons.clearFilters.btnText') }}</span>
                    </button>
                </div>
            </div>
            <table class="table table-responsive table-bordered table-hover" v-if="budgetReport">
                <thead>
                    <tr>
                        <th rowspan="2" v-if="!isLockedForEdit && (hasFinancialControlRights || hasFinancialControlUnlockRights)">{{ $t('budgetReport.financialControl') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.participants') }}</th>
                        <th colspan="3">{{ $t('budgetReport.businessTrip') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.daysCount') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.daysRate') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.daysRateSum') }}</th>
                        <th colspan="2">{{ $t('budgetReport.nights') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.nightsCount') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.singlePrice') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.apartmentSum') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.roadGoingMoney') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.date') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.roadReturningMoney') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.date') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.roadMoneyAll') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.all') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.payedWithoutApartment') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.paymentDate') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.excerpt') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.accountingProgram') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.difference') }}</th>
                        <th rowspan="2">{{ $t('budgetReport.note') }}</th>
                        <th rowspan="2">{{ $t('filesUpload') }}</th>
                    </tr>
                    <tr>
                        <th>{{ $t('budgetReport.businessTripOrderNumber') }}</th>
                        <th>{{ $t('from') }}</th>
                        <th>{{ $t('to') }}</th>
                        <th>{{ $t('from') }}</th>
                        <th>{{ $t('to') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr>{{ filteredItems }}</tr> -->
                    <budget-report-item v-for="(item, index) in filteredItems"
                        :key="index"
                        :item="item"
                        :has-financial-control-rights="hasFinancialControlRights"
                        :has-financial-control-unlock-rights="hasFinancialControlUnlockRights"
                        :index="index"
                        :event-date-from="eventDateFrom"
                        :event-date-to="eventDateTo"
                        @onItemUploadFilesClicked="onItemUploadFilesClicked"
                        @clickedItemIndex="clickedItemIndex"
                        :is-locked-for-edit="isLockedForEdit"
                        @daySumChanged="daySumChanged"
                        @roadSumChanged="roadSumChanged"
                        @apartmentSumChanged="apartmentSumChanged"
                        @totalSumChanged="totalSumChanged"
                        @fileToBeRemoved="fileToRemoveFromGrid"
                        @unlockFinancialControl="onUnlockFinancialControl"
                    />
                </tbody>
                <tfoot>
                    <tr>
                        <td v-if="!isLockedForEdit && (hasFinancialControlRights || hasFinancialControlUnlockRights)"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="font-weight-bold">{{ daySumTotal }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="font-weight-bold">{{ apartmentSumTotal }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="font-weight-bold">{{ roadSumTotal }}</td>
                        <td class="font-weight-bold">{{ totalSum }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
            <div v-if="canWrite && !isLockedForEdit">
                <button class="btn btn-primary" @click="onSave">{{ $t('save') }}</button>
                <span v-if="budgetReport.isNew === true" class="badge badge-info">Отчетът не е запаметен</span>
            </div>
        </div>

        <!-- File upload modal -->
        <div v-if="showFileUploadModal && !isLockedForEdit" id="fileUploadModal" class="modal" tabindex="-1" role="dialog"
             data-backdrop="static">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('filesUpload') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="closeFileUploadModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <vs-upload ref="fileUpload"
                                :key="uploadKey"
                                :showUploadButton="false"
                                :text="$t('addFile')"
                                @change="fileAdded"
                                @on-delete="fileRemoved"/>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="font-weight-bold" :for="'reportingDocsSelector' + _uid">{{$t('fileSelection.reportingDocs')}}</label>
                                <dynamic-multi-select
                                    :apiUrl="`/api/events/${registerEntityId}/reportingDocsDropdownModels`"
                                    :id="'reportingDocsSelector' + _uid"
                                    :name="'reportingDocsSelector' + _uid"
                                    filter="contains"
                                    :height="500"
                                    @input="selectedReportingDocInput">
                                </dynamic-multi-select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12">
                                <label class="font-weight-bold" :for="'organizationalDocsSelector' + _uid">{{$t('fileSelection.organizationalDocs')}}</label>
                                <dynamic-multi-select
                                    :apiUrl="`/api/events/${registerEntityId}/organizationalDocsDropdownModels`"
                                    :id="'organizationalDocsSelector' + _uid"
                                    :name="'organizationalDocsSelector' + _uid"
                                    filter="contains"
                                    :height="500"
                                    @input="selectedOrgDocInput">
                                </dynamic-multi-select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                @click="closeFileUploadModal">{{ $t('buttons.close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BudgetReportItemModel, BudgetReportModel } from '@/models/models';
    import BudgetReportItem from './BudgetReportItem';
    import Toggle from '../toggle/Toggle';
    import { BudgetReportFileModel } from '@/models/file.models'
    import DynamicMultiSelect from '@/components/dropdown/DynamicMultiSelect';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            BudgetReportItem,
            Toggle,
            DynamicMultiSelect
        },
        props: {
            registerEntityId: {
                type: [Number, String]
            },
            eventDateFrom: {
                type: [Date, String]
            },
            eventDateTo: {
                type: [Date, String]
            },
            canWrite: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                people: this.$parent.$parent.people,
                isNew: true,
                loading: true,
                budgetReport: null,
                markAllWithFinancialControl: false,
                showFileUploadModal: true,
                fileUploadItemIndex: null,
                clickedFileItemIndex: null,
                daySumTotal: '',
                roadSumTotal: '',
                apartmentSumTotal: '',
                totalSum: '',
                searchQuery: '',
                unloadedParticipants: null,
                uploadKey: 0
            }
        },
        computed: {
            ...mapGetters(['fileSizeLimit']),
            hasFinancialControlRights() {
                return this.$store.getters.claims.financialControl.read
                    || this.$store.getters.claims.financialControl.create
                    || this.$store.getters.claims.financialControl.update;
            },
            hasFinancialControlUnlockRights() {
                return this.$store.getters.claims.financialControl.delete
            },
            filteredItems() {
                if (!this.budgetReport) return [];

                const items = this.budgetReport.items;
                if (!this.searchQuery) return items.sort((a, b) => a.personName.localeCompare(b.personName));

                const filtered = this.budgetReport.items.filter(x => this.$helpers.filter(x, this.searchQuery));

                return filtered.sort((a, b) => a.personName.localeCompare(b.personName));
            }
        },
        methods: {
            loadData() {
                if (this.registerEntityId) {
                    this.$http.get(`/api/BudgetReport/${this.registerEntityId}/`).then(result => {
                        if (result.data) {
                            this.isNew = false;
                            this.budgetReport = new BudgetReportModel(result.data);
                            this.loading = false;
                            this.checkForUnloadedParticipants();
                        } else {
                            this.loadNewNotSavedBudgetReport();
                        }
                    }).catch(error => {
                        this.loading = false;
                    });
                } else {
                    this.loadNewNotSavedBudgetReport();
                }
            },
            loadNewNotSavedBudgetReport() {
                if (!this.budgetReport) {
                    this.budgetReport = new BudgetReportModel({ registerEntityId: this.registerEntityId, isNew: true });
                }

                this.$http.get(`/api/DynamicRegisters/participants/${this.registerEntityId}`).then(result => {
                    let vm = this;
                    result.data.forEach(person => {
                        if (!vm.budgetReport.items.some(x => x.personId === person.id)) {
                            vm.budgetReport.items.push(new BudgetReportItemModel({
                                personId: person.id,
                                personName: `${person.fullName}`,
                                personNameEn: `${person.fullNameEn}`
                            }));
                        }
                    });

                    this.checkForUnloadedParticipants();
                    this.loading = false;
                }).catch(error => {
                    // TODO:
                    this.loading = false;
                });
            },
            async checkForUnloadedParticipants() {
                if (!this.budgetReport || !this.budgetReport.items) return;

                const participants = (await this.$http.get(`/api/DynamicRegisters/participants/${this.registerEntityId}`)).data;
                if (!participants || participants.length === 0) return;

                this.unloadedParticipants = participants.filter(x => !this.budgetReport.items.some(i => i.personId === x.id));
            },
            openFileUploadModal() {
                $('#fileUploadModal').modal();
            },
            closeFileUploadModal() {
                $('#fileUploadModal').modal('hide');
                this.showFileUploadModal = false;
                setTimeout(() => { // Workaround за да се изчиства vuesax file upload компонентата
                    this.showFileUploadModal = true;
                }, 200);
            },
            onItemUploadFilesClicked(index) {
                this.fileUploadItemIndex = index;
                this.openFileUploadModal();
            },
            fileAdded() {
                let file = this.$refs.fileUpload.$refs.fileInput.files[0];
                if (file.size > this.fileSizeLimit) { // 10 MB
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.fileSizeLimitExceeded', { maxSize: this.fileSizeLimit / 1048576 }),
                        color: 'danger',
                    });
                    // Force re-render of the upload component by changing its key
                    this.uploadKey++;
                    return;
                }

                this.budgetReport.items[this.fileUploadItemIndex].files.push(new BudgetReportFileModel({
                    fileName: file.name,
                    content: file,
                    budgetReportItemId: this.budgetReport.items[this.fileUploadItemIndex].id
                }));
            },
            fileRemoved(fileToRemove) {
                const indexToDelete = this.budgetReport.items[this.fileUploadItemIndex].files.findIndex(x => x.name === fileToRemove.name);
                this.budgetReport.items[this.fileUploadItemIndex].files.splice(indexToDelete, 1);
            },
            fileToRemoveFromGrid(file) {
                var fileToRemove = file;
                const indexToDelete = this.budgetReport.items[this.clickedFileItemIndex].files.indexOf(fileToRemove);
                this.budgetReport.items[this.clickedFileItemIndex].files.splice(indexToDelete, 1);
                if (fileToRemove.id) {
                    this.budgetReport.filesToDelete.push({
                        fileId: file.id,
                        itemId: file.budgetReportItemId
                    });
                }
            },
            clickedItemIndex(index) {
                this.clickedFileItemIndex = index;
            },
            daySumChanged() {
                const total = this.calculateTotal('daySum');
                this.daySumTotal = total;
            },
            roadSumChanged() {
                const total = this.calculateTotal('roadSum');
                this.roadSumTotal = total;
            },
            apartmentSumChanged() {
                const total = this.calculateTotal('appartmentSum');
                this.apartmentSumTotal = total;
            },
            totalSumChanged() {
                const total = this.calculateTotal('allMoneySum');
                this.totalSum = total;
            },
            calculateTotal(propertyName) {
                let totalSum = 0;
                this.budgetReport.items.forEach(item => {
                    if (item[propertyName]) {
                        totalSum += item[propertyName];
                    }
                });
                const total = Math.round(totalSum * 100) / 100;
                return total;
            },
            onSave() {
                if (this.isNew) {
                    this.create();
                } else {
                    this.edit();
                }
            },
            create() {
                this.loading = true;
                const reportToSend = new BudgetReportModel({
                    registerEntityId: this.budgetReport.registerEntityId
                });

                this.budgetReport.items.forEach(item => {
                    if (this.$helpers.isFloat(item.days)) {
                        item.days = Math.round(item.days);
                    }

                    if (this.$helpers.isFloat(item.nightsCount)) {
                        item.nightsCount = Math.round(item.nightsCount);
                    }

                    let newItem = new BudgetReportItemModel(item);
                    newItem.files = [];
                    newItem.eventDocuments = [];

                    if (item.files) {
                        item.files.forEach(file => {
                            if (!file.id && (file.reportingDocId || file.orgDocId)) {
                                newItem.eventDocuments.push({
                                    id: file.id,
                                    reportingDocId: file.reportingDocId,
                                    orgDocId: file.orgDocId
                                });
                            }
                        })
                    }

                    reportToSend.items.push(newItem);
                });

                this.$http.post('/api/BudgetReport', reportToSend).then(result => {
                    this.loading = false;
                    // TODO: Map ids first... this.uploadFiles();
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        color: 'success'
                    });
                    this.loadData();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                const reportToSend = new BudgetReportModel({
                    registerEntityId: this.budgetReport.registerEntityId
                });

                this.budgetReport.items.forEach(item => {
                    if (this.$helpers.isFloat(item.days)) {
                        item.days = Math.round(item.days);
                    }

                    if (this.$helpers.isFloat(item.nightsCount)) {
                        item.nightsCount = Math.round(item.nightsCount);
                    }

                    let newItem = new BudgetReportItemModel(item);
                    newItem.files = [];
                    newItem.eventDocuments = [];

                    if (item.files) {
                        item.files.forEach(file => {
                            if (!file.id && (file.reportingDocId || file.orgDocId)) {
                                newItem.eventDocuments.push({
                                    id: file.id,
                                    reportingDocId: file.reportingDocId,
                                    orgDocId: file.orgDocId
                                });
                            }
                        })
                    }

                    reportToSend.items.push(newItem);
                });

                reportToSend.filesToDelete = this.budgetReport.filesToDelete;

                this.$http.put('/api/BudgetReport', reportToSend).then(result => {
                    this.loading = false;
                    this.uploadFiles();
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        color: 'success'
                    });
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        color: 'danger'
                    });
                });
            },
            uploadFiles() {
                this.loading = true;
                let files = [];
                this.budgetReport.items.forEach(item => {
                    item.files.forEach(file => {
                        if (!file.id && !file.reportingDocId && !file.orgDocId) {
                            files.push(file);
                        }
                    });
                });

                if (files.length > 0) {
                    const vm = this;
                    this.$http.all(this.uploadFilesAsync(vm, files)).then(result => {
                        this.loading = false;
                        this.loadData();
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successUploadingFiles'),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    }).catch(() => {
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.errorUploadingFiles'),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
                } else {
                    this.loading = false;
                }
            },
            uploadFilesAsync(vm, files) {
                let requests = [];
                files.forEach(function (file) {
                    let formData = new FormData();
                    formData.append('itemId', file.budgetReportItemId);
                    formData.append('files', file.content, file.fileName);
                    requests.push(vm.$http.post('/api/BudgetReport/UploadFiles', formData));
                });

                return requests;
            },
            onUnlockFinancialControl(budgetReportId) {
                this.doUnlockFinancialControl([budgetReportId])
            },
            doUnlockFinancialControl(budgetReportIds) {
                this.$http.put('/api/BudgetReport/UnlockFinancialControl', { ids: budgetReportIds }).then(() => {
                    this.loading = false;
                    this.loadData();
                    this.$vs.notify({
                        title: this.$t('updateSuccess'),
                        text: '',
                        color: 'success'
                    });
                }).catch((error) => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        color: 'danger'
                    });
                });
            },
            selectedReportingDocInput(val, items) {
                if (!items) {
                    items = [];
                }

                const toAdd = items.filter(x => !this.budgetReport.items[this.fileUploadItemIndex].files.some(f => f.reportingDocId === x.id));
                toAdd.forEach(file => {
                    this.budgetReport.items[this.fileUploadItemIndex].files.push(new BudgetReportFileModel({
                        fileName: file.item.fileName,
                        budgetReportItemId: this.budgetReport.items[this.fileUploadItemIndex].id,
                        reportingDocId: file.id
                    }));
                });

                if (this.budgetReport.items && this.budgetReport.items[this.fileUploadItemIndex].files) {
                    const toRemove = this.budgetReport.items[this.fileUploadItemIndex].files.filter(x => x.reportingDocId && !items.some(f => f.id === x.reportingDocId));

                    toRemove.forEach(file => {
                        const indexToDelete = this.budgetReport.items[this.fileUploadItemIndex].files.indexOf(file);
                        this.budgetReport.items[this.fileUploadItemIndex].files.splice(indexToDelete, 1);
                    });
                }
            },
            selectedOrgDocInput(val, items) {
                if (!items) {
                    items = [];
                }

                const toAdd = items.filter(x => !this.budgetReport.items[this.fileUploadItemIndex].files.some(f => f.orgDocId === x.id));
                toAdd.forEach(file => {
                    this.budgetReport.items[this.fileUploadItemIndex].files.push(new BudgetReportFileModel({
                        fileName: file.item.fileName,
                        budgetReportItemId: this.budgetReport.items[this.fileUploadItemIndex].id,
                        orgDocId: file.id
                    }));
                });

                if (this.budgetReport.items && this.budgetReport.items[this.fileUploadItemIndex].files) {
                    const toRemove = this.budgetReport.items[this.fileUploadItemIndex].files.filter(x => x.orgDocId && !items.some(f => f.id === x.orgDocId));

                    toRemove.forEach(file => {
                        const indexToDelete = this.budgetReport.items[this.fileUploadItemIndex].files.indexOf(file);
                        this.budgetReport.items[this.fileUploadItemIndex].files.splice(indexToDelete, 1);
                    });
                }
            },
        },
        watch: {
            markAllWithFinancialControl: function (newVal, oldVal) {
                this.budgetReport.items.forEach(item => {
                    if (!item.disalbedForEdit) {
                        item.financialControl = newVal;
                    }
                });
            }
        },
        async mounted() {
            await this.loadData();
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        }
    }
</script>

<style scoped>
    thead tr:nth-child(1) th {
        background: white;
        position: sticky;
        top: 0;
        z-index: 10;
    }
    .table-responsive {
        height:400px;
        overflow:scroll;
    }
    th {
        font-size: 0.8rem !important;
    }
</style>
